import { Component } from 'preact';
import round from 'lodash/round';
import style from './style';
import Calc from '../calc';
import Icon from '../icon';

export default class Wrapper extends Component {
  state = {
    ratio: '1:16',
    strength: 'mildest',
    water: 10,
    waterConverted: 296,
    beans: 18.5,
    icon: 'small',
    waterClassName: 'title',
    coffeBeanClassName: 'title'
  };

  // Retrieve persisted state from local storage.
  getLocalStorage() {
    return JSON.parse(localStorage.getItem('calc.coffee') || '{}');
  }

  // Persist the state in local storage if it's available.
  componentDidMount() {
    const localStorageState = this.getLocalStorage();
    this.setState(localStorageState);
  }

  // Update local storage after the state updates.
  componentDidUpdate() {
    localStorage.setItem('calc.coffee', JSON.stringify(this.state));

    // Update the theme color too.
    this.props.updateTheme(this.state.strength);
  }

  setStength = e => {
    const strength = e.target.value;

    switch (strength) {
      case 'mildest':
        this.setState({ ratio: '1:16', strength: strength });
        break;
      case 'mild':
        this.setState({ ratio: '1:15', strength: strength });
        break;
      case 'medium':
        this.setState({ ratio: '1:13', strength: strength });
        break;
      case 'strong':
        this.setState({ ratio: '1:11', strength: strength });
        break;
      case 'strongest':
        this.setState({ ratio: '1:10', strength: strength });
        break;
      default:
        console.error('Oops. No stength set.');
    }

    this.setAmount(null, strength);
  };

  setAmount = (e, strength) => {
    const amount = e !== null ? e.target.value : null;
    strength = strength || this.state.strength;

    switch (strength) {
      case 'mildest':
        this.calculateCoffee(amount, 16);
        break;
      case 'mild':
        this.calculateCoffee(amount, 15);
        break;
      case 'medium':
        this.calculateCoffee(amount, 13);
        break;
      case 'strong':
        this.calculateCoffee(amount, 11);
        break;
      case 'strongest':
        this.calculateCoffee(amount, 10);
        break;
      default:
        console.error('Oops. No stength set.');
    }
  };

  calculateCoffee = (brewedCoffee, ratioNum) => {
    brewedCoffee = brewedCoffee === null ? this.state.water : brewedCoffee;
    let waterInGrams = round(brewedCoffee * 29.57, 1);
    let coffeeBeans = round((brewedCoffee * 29.5735) / ratioNum, 1);

    // We only want to show one decimal place if the number is under three digits.
    waterInGrams = waterInGrams >= 100 ? round(waterInGrams) : waterInGrams;
    coffeeBeans = coffeeBeans >= 100 ? round(coffeeBeans) : coffeeBeans;

    // Check the length of the digits so we can reduce the font size a bit.
    const waterDigits = (waterInGrams + '').replace('.', '').length;
    const coffeeBeanDigits = (coffeeBeans + '').replace('.', '').length;

    // Update the icon if necessary.
    this.updateIcon(brewedCoffee);

    // Set our new water / bean strings.
    this.setState({
      water: brewedCoffee,
      waterConverted: waterInGrams,
      beans: coffeeBeans,
      waterClassName:
        waterDigits >= 4 && waterInGrams <= 17742 ? 'titleLarge' : 'title',
      coffeBeanClassName:
        coffeeBeanDigits >= 4 && waterInGrams <= 17742 ? 'titleLarge' : 'title'
    });
  };

  updateIcon = amount => {
    if (amount <= 12) {
      this.setState({ icon: 'small' });
    } else if (amount > 12 && amount <= 16) {
      this.setState({ icon: 'medium' });
    } else if (amount > 16 && amount <= 99) {
      this.setState({ icon: 'large' });
    } else {
      this.setState({ icon: 'lolok' });
    }
  };

  render() {
    return (
      <div class={style.wrapper}>
        <div class={style.top}>
          <h2 class={style[this.state.coffeBeanClassName]}>
            {this.state.waterConverted > 17742 ? (
              <span class={style.lolk}>lol</span>
            ) : (
              this.state.beans
            )}
            <span class={style.unit}>g</span>
            {/* <button title="grams" class={style.btn}>
              <span class={style.btnText}>g</span>
            </button> */}
          </h2>
          <h3 class={style.label}>Coffee</h3>
          <h2 class={style[this.state.waterClassName]}>
            {this.state.waterConverted > 17742 ? (
              <span class={style.lolk}>ok</span>
            ) : (
              this.state.waterConverted
            )}
            {this.state.waterConverted > 17742 ? (
              <span class={style.unit}>😂</span>
            ) : (
              <span class={style.unit}>g</span>
            )}
          </h2>
          <h3 class={style.label}>Water</h3>
        </div>
        <Calc
          setAmount={this.setAmount}
          setStength={this.setStength}
          ratio={this.state.ratio}
          water={this.state.water}
          strength={this.state.strength}
        />
        <Icon size={this.state.icon} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/wrapper/index.js